import { uiText, useUiLanguage } from '@/i18n/interface';

import React from 'react';

interface CapacityIndicatorProps {
  attendanceCount: number;
  maxParticipants: number;
}

const CapacityIndicator: React.FC<CapacityIndicatorProps> = ({ attendanceCount, maxParticipants }) => {
  useUiLanguage();
  const percentage = Math.min((attendanceCount / maxParticipants) * 100, 100);

  return (
    <>
      <div className="mt-3 w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-red-600 h-2 rounded-full transition-all duration-300"
          style={{ width: `${percentage}%` }}
        />
      </div>
      <p className="text-xs text-gray-500 mt-1">
        {Math.round(percentage)}{uiText("% capacity")}</p>
    </>
  );
};

export default CapacityIndicator;
